export default __webpack_public_path__ + "static/media/Q32022.3ae20627.pdf";